import React, { createContext, useContext, useEffect, useState } from "react";
import { dictionaries } from "./dictionaries";

const I18nCtx = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("gegee_lang") || "mn");
  useEffect(() => { localStorage.setItem("gegee_lang", lang); }, [lang]);
  const t = (path) => {
    const parts = path.split(".");
    let v = dictionaries[lang];
    for (const p of parts) { v = v?.[p]; if (v == null) break; }
    if (v == null) {
      let f = dictionaries.en;
      for (const p of parts) { f = f?.[p]; if (f == null) break; }
      return f ?? path;
    }
    return v;
  };
  return (
    <I18nCtx.Provider value={{ lang, setLang, t }}>
      {children}
    </I18nCtx.Provider>
  );
}

export const useI18n = () => useContext(I18nCtx);
